import React from "react";
import { GroupProps } from "../types";
import { Box, Typography } from "@mui/material";

export function Group({ heading, children, className }: GroupProps) {
    return (
        <Box className={className} sx={{ mb: 1 }}>
            {heading && (
                <Typography 
                    variant="caption" 
                    sx={{ 
                        px: 2, 
                        py: 1,
                        display: "block",
                        fontWeight: 600,
                        color: "text.secondary",
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        fontSize: "0.7rem",
                    }}
                >
                    {heading}
                </Typography>
            )}
            {children}
        </Box>
    );
}

export default Group;
